















































































































































import { Component, Vue, Inject } from 'vue-property-decorator'
import Advert from '@/components/Advert/Advert.vue'

@Component({ components: { Advert } })
export default class Download extends Vue {
  loaded: boolean = false // 页面是否已经加载完成
  downloadStatus = {
    shansuan: false,
    teacher: false,
    plstudent: false
  }
  to (path: string) {
    Lib.router.push(path)
  }
  hideDownload (appName: string) {
    if (appName === 'shansuan') {
      this.downloadStatus.shansuan = false
    } else if (appName === 'teacher') {
      this.downloadStatus.teacher = false
    } else if (appName === 'plstudent') {
      this.downloadStatus.plstudent = false
    }
  }
  showDownload (appName: string) {
    if (appName === 'shansuan') {
      this.downloadStatus.shansuan = true
    } else if (appName === 'teacher') {
      this.downloadStatus.teacher = true
    } else if (appName === 'plstudent') {
      this.downloadStatus.plstudent = true
    }
  }
  created () {
    this.loaded = true
  }
  mounted () {
    // 兼容prerender-spa-plugin
    Lib.dispatchEvent(document, 'custom-render-trigger')
    let downloadShansuan = document.querySelector('.product-item-download-shansuan')
    let btnCloseShansuan = document.querySelector('.product-item-close-shansuan')
    let btnDownloadShansuan = document.querySelector('.product-btn-download-shansuan')
    let downloadTeacher = document.querySelector('.product-item-download-teacher')
    let btnCloseTeacher = document.querySelector('.product-item-close-teacher')
    let btnDownloadTeacher = document.querySelector('.product-btn-download-teacher')
    let downloadPlstudent = document.querySelector('.product-item-download-plstudent')
    let btnClosePlstudent = document.querySelector('.product-item-close-plstudent')
    let btnDownloadPlstudent = document.querySelector('.product-btn-download-plstudent')

    if (btnDownloadShansuan && downloadShansuan) {
      btnDownloadShansuan.addEventListener('click', () => {
        downloadShansuan!.classList.add('show')
      })
    }
    if (btnCloseShansuan && downloadShansuan) {
      btnCloseShansuan.addEventListener('click', () => {
        downloadShansuan!.classList.remove('show')
      })
    }
    if (btnDownloadTeacher && downloadTeacher) {
      btnDownloadTeacher.addEventListener('click', () => {
        downloadTeacher!.classList.add('show')
      })
    }
    if (btnCloseTeacher && downloadTeacher) {
      btnCloseTeacher.addEventListener('click', () => {
        downloadTeacher!.classList.remove('show')
      })
    }
    if (btnDownloadPlstudent && downloadPlstudent) {
      btnDownloadPlstudent.addEventListener('click', () => {
        downloadPlstudent!.classList.add('show')
      })
    }
    if (btnClosePlstudent && downloadPlstudent) {
      btnClosePlstudent.addEventListener('click', () => {
        downloadPlstudent!.classList.remove('show')
      })
    }
  }
}
